<template>

    <div class="giftcard-form-new form-wrapper">
        <div class="gift-card-container">
            <el-form
                :model="giftcardForm"
                :rules="rules"
                ref="giftcardForm"
                method="POST"
                @submit.prevent.native="sendGifcard($event)"
                class="card"
            >

                <el-row v-if="!done" :gutter="40" type="flex" justify="space-between">

                    <!-- Form Data -->
                    <el-col :xs="24" :md="14">

                        <div class="section">
                            <div class="section-header">
                                <h2>Send Gift Cards to your friends</h2>
                                <p>Gift Cards are delivered via email instantly and can apply to any of our services.</p>
                            </div>

                            <div class="section-body">

                                <!-- Recipient -->
                                <el-row :gutter="20">

                                    <el-col :xs="24" :md="12">
                                        <el-form-item prop="recipient_name" label="Recipient Name">
                                            <el-input placeholder="John Doe" v-model="giftcardForm.recipient_name" required></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :xs="24" :md="12">
                                        <el-form-item prop="recipient_email" label="Recipient Email">
                                            <el-input placeholder="johndoe@mail.com" v-model="giftcardForm.recipient_email"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <!-- Sender -->
                                <el-row :gutter="20">

                                    <el-col :xs="24" :md="12">
                                        <el-form-item prop="sender_name" label="Sender Name">
                                            <el-input placeholder="Jane Doe" v-model="giftcardForm.sender_name" required></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :xs="24" :md="12">
                                        <el-form-item prop="sender_email" label="Sender Email">
                                            <el-input placeholder="janedoe@mail.com" v-model="giftcardForm.sender_email" required></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="24">
                                        <el-form-item prop="amount" label="Amount">
                                            <el-input placeholder="20" v-model.number="giftcardForm.amount" required>
                                                <template slot="prepend">{{currency}}</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <!-- <el-row :gutter="20">
                                    <el-col :xs="24" :md="24">
                                        <nocaptcha
                                            :appkey="'FFFF00000000016AB730'"
                                            :scene="'test'"
                                            @load="onLoad"
                                            @callback="onSuccess"
                                            @error="onError"
                                            class="no-captcha"
                                        ></nocaptcha>
                                    </el-col>
                                </el-row> -->

                            </div>

                            <div class="gift-card-responsive">

                            </div>
                        </div>

                        <Divider :primary-color="customizer.appearance.accentColor"  />

                        <div class="section">

                            <div class="section-header">
                                <h2>Credit Card Details</h2>
                            </div>

                            <div class="section-body">

                                <el-row :gutter="20" v-if="stripeKey">

                                    <el-col :span="24">
                                        <el-form-item>
                                            <div id="card-element" class="stripe-card">
                                                <!-- A Stripe Element will be inserted here. -->
                                            </div>

                                            <div id="card-errors" class="card-errors" role="alert">
                                                <!-- Used to display form errors. -->
                                            </div>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="24">
                                        <el-form-item>

                                            <!-- Error -->
                                            <el-alert
                                                v-if="error"
                                                title="Something went wrong"
                                                description="Please complete the form to submit"
                                                type="error"
                                                style="margin-bottom: 16px;"
                                                show-icon
                                            />

                                            <el-button :class="{'btn-disabled': !stripeKey}" :loading="loading" type='primary' native-type='submit' @click.stop.prevent="sendGifcard($event)">
                                                Send Gift Card
                                            </el-button>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row v-else>
                                    <el-alert title="Warning: Stripe Keys Required" type="warning" style="margin-bottom: 16px;"/>
                                </el-row>

                                <el-row>
                                    <cCardBrands class="card-brands"></cCardBrands>
                                </el-row>

                            </div>

                        </div>

                    </el-col>

                    <!-- Column Divider -->
                    <el-col :span="0" style="position:relative; display:flex" class="column-divider">
                        <div class="sectionSeparator divider"></div>
                    </el-col>

                    <!-- Sidebar -->
                    <el-col :span="10" class="sidebar">

                        <div class="card-front">
                            <CardFront :primary-color="customizer.appearance.accentColor"></CardFront>
                            <div class="card-info">

                                <!-- SVG visibility hidden -->
                                <svg width="337" height="185" viewBox="0 0 337 185" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-test"></svg>

                                <div class="text">
                                    <div class="company-name">{{ companyName }}</div>
                                    <div class="amount">{{ currency }}{{ giftcardForm.amount }}</div>
                                </div>

                            </div>
                        </div>

                        <div class="card-back">
                            <CardBack :primary-color="customizer.appearance.accentColor"></CardBack>
                            <div class="card-info">

                                <!-- SVG visibility hidden -->
                                <svg width="337" height="185" viewBox="0 0 337 185" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-test"></svg>

                                <div class="text">
                                    <div class="description">
                                        Dear <span v-if="giftcardForm.recipient_name">{{ giftcardForm.recipient_name }}</span> <span v-else>Recipient Name</span>, <br><br>
                                        Hope you're having a great day! Thought you'd enjoy a free home cleaning. Take a break from your chores with this gift card. Enjoy!
                                    </div>

                                    <div class="code">
                                        Code: XXXX-XXXX-XXXX
                                    </div>
                                </div>

                            </div>
                        </div>

                    </el-col>

                </el-row>

                <el-row v-else>
                    <div class="sectionSeparator">
                        <GiftCardDone :client="clientId" :company_logo="companyLogo" :company_name="companyName"></GiftCardDone>
                    </div>
                </el-row>

            </el-form>
        </div>
    </div>

</template>

<script>

import GiftCardDone from "./GiftCardDone.vue";
import cCardBrands from '@components/c-card-brands-v2/index.vue'
import nocaptcha from 'vue-nocaptcha/lib/nocaptcha.js'
import Divider from '../bookingForm/src/Divider.vue'
import CardBack from "./components/CardBack.vue";
import CardFront from "./components/CardFront.vue";

export default {
    props: {
        clientId : {
            type     : String,
            required : true
        },
        stripeKey: {
            type     : String,
            required : true
        },
        companyName: {
            type     : String,
            required : true
        },
        companyLogo: {
            type: String,
        },
        currency:    {
            type     : String,
            required : true
        },
        locationId: {
            type     : String,
            required : true,
        },
        customizer:{
            type: Object,
            default: () => ({
                appearance: {
                    formStyle: "default_new",
                    accentColor: "#4285f4",
                    servicesStyle: "default",
                    formBorderRadius: 30,
                    inputBorderRadius: 12}
            })
        }
    },

    components: {
        GiftCardDone,
        cCardBrands,
        nocaptcha,
        Divider,
        CardBack,
        CardFront
    },

    data() {
        /* Custom Validations */

        var checkNumbers = (rule, value, callback) => {
            var RegExpression = /^\d+$/;
            if(RegExpression.test(value)) {
                callback();
            } else {
                callback(new Error('Amount can only contain numbers'));
            }
        };

        var checkNames = (rule, value, callback) => {
            var RegExpression = /^[a-zA-Z\s]*$/;
            if(RegExpression.test(value)) {
                callback();
            } else {
                callback(new Error('Name cannot contain numbers'));
            }
        };

        return {
            primaryColor: '#2f80ed',
            verified     : false,
            card         : null,
            done         :  0,
            error        : false,
            rules        : {
                amount          : [
                    { required: true, type: "number", min:20, max:2000, trigger: ['blur', 'change']},

                ],
                sender_name     : [
                    { required: true, message: 'Sender Name is required', trigger: ['blur', 'change'] },
                    { validator: checkNames, trigger: 'blue' }
                ],
                sender_email    : [
                    { required: true, message: 'Sender Email is required', trigger: 'blur' },
                    { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                ],
                recipient_name  : [
                    { required: true, message: 'Recipient Name is required', trigger: ['blur', 'change'] },
                    { validator: checkNames, trigger: 'blue' }
                ],
                recipient_email : [
                    { required: true, message: 'Recipient Email is required', trigger: 'blur' },
                    { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                ],
            },
            stripe       : null,
            elements     : null,
            complete     : false,
            stripeToken  : null,
            giftcardForm : {
                amount          : 20,
                sender_name     : '',
                sender_email    : '',
                recipient_name  : '',
                recipient_email : '',
                locationd_id    : this.locationId
            },
            loading : false,

        };

    },

    watch: {

        'customizer.appearance': {
            deep: true,
            immediate: true,
            handler() {

                if (this.customizer.appearance?.accentColor) {
                    document.querySelector(":root").style.setProperty('--color-primary', this.customizer.appearance.accentColor);
                    document.querySelector(":root").style.setProperty('--input-border-radius', this.customizer.appearance.inputBorderRadius + 'px');
                    document.querySelector(":root").style.setProperty('--form-border-radius', this.customizer.appearance.formBorderRadius + 'px');
                }
            }
        },


        stripeToken(after, before) {
            var app = this

            if(app.stripeToken){
                app.error    = false

                app.$http({
                    url: `gift_card/save`,
                    method: 'POST',
                    data: {
                        member_id    : app.clientId,
                        stripeToken  : app.stripeToken,
                        giftcardForm : app.giftcardForm,
                        location_id  : app.locationId,
                    }
                }).then((res) => {
                    app.done = true
                }, (res) => {
                    this.loading = false
                    this.error = true
                })
            }
        }
    },

    mounted() {
        // app.token = document.querySelector('meta[name="_token"]').getAttribute('content')
        this.loadStripe()
        this.$nextTick(() => this.$emit('ready'))
    },

    methods: {
        onLoad()
        {
            // console.log('it loaded ok')
        },
        onSuccess() {
            this.verified = true
        },
        onError() {

        },
        sendGifcard(e){
            e.preventDefault()

            this.$refs['giftcardForm'].validate((valid, errors) => {
                if (valid) {

                    this.loading = true
                    this.stripe.createToken(this.card).then((result) => {
                        if (result.error) {
                            this.error = true
                            this.loading = false

                            var errorElement = document.getElementById('card-errors')
                            errorElement.textContent = result.error.message
                        }
                        else {
                            this.error = false
                            this.stripeToken = result.token.id
                        }
                    })

                } else {
                    this.error = true
                    this.loading = false

                    // scroll first error element
                    // this.$nextTick(() => {
                    //     document.querySelectorAll('.el-form-item__error')[0]?.closest(".sectionSeparator").scrollIntoView();
                    // })
                    return false
                }
            });

        },

        loadStripe(){
            var app = this;

            if(app.stripeKey){
                app.stripe   = Stripe(app.stripeKey)
                app.elements = this.stripe.elements(

                    {
                        fonts: [
                            {
                            // integrate your font into stripe
                            cssSrc: 'https://fonts.googleapis.com/css?family=Inter:400,500,600',
                            }
                        ]
                    }

                )

                var style = {
                    base: {
                        color          : '#606266',
                        fontSize       : '14px',
                        fontFamily     : "'Inter', sans-serif",
                        fontWeight     : '400',
                        lineHeight     : this.$guardModel === 'customer' ? '38px': '44px',

                        '::placeholder': {
                            color         : '#C0C4CC',
                            fontSize      : '14px',
                            fontWeight    : '400',
                            fontFamily    : "'Inter', sans-serif",
                            textTransform : 'capitalize',
                        }
                    },

                    invalid: {
                        color     : '#fa755a',
                        iconColor : '#fa755a'
                    }
                }

                app.card = this.elements.create('card', {hidePostalCode: true, style: style})
                app.card.mount('#card-element')

                this.card.addEventListener('change', function(event) {
                    var displayError = document.getElementById('card-errors')

                    if (event.error) {
                        displayError.textContent = event.error.message
                    } else {
                        displayError.textContent = ''
                    }
                })
            }
        },


    },
    computed: {

    }
}
</script>

<style>
    :root {
        --color-primary: rgb(74, 126, 243);
        --input-border-radius: 10px;
        --form-border-radius: 20px;
    }

    .el-picker-panel {
        font-family: 'Inter', sans-serif;
    }
</style>

<style lang="scss" scoped>

    // GENERAL STYLES
    @font-face {
        font-family: 'Inter';
        src: url('../bookingForm/assets/fonts/inter.woff2') format("woff2");
    }
    * {
        font-family: 'Inter', sans-serif;
    }
    h2 {
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        margin-top: 0;
        margin-bottom: 8px;
    }
    p {
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        margin: 0;
        color: #8492A6;
    }
    .form-wrapper {
        margin: 0 auto;
        display: flex;
        justify-content: center;
    }
    .gift-card-container {
        max-width: 1100px !important;
        height: 100%;
        width: 100vw !important;
    }
    .card {
        background-color: white;
        padding: 40px;
        border-radius: var(--form-border-radius);
    }
    .section {
        .section-header {
            margin-bottom: 16px;
        }
    }
    .form-wrapper {
        margin: 0 auto;
        display: flex;
        justify-content: center;
    }
    .divider {
        width: 0px;
        position: absolute;
        border-left: 1px solid #E6EAF0;
        display: flex;
        height: 100%;
        right: 40%;
    }
    .column-divider {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    // FORM ITEMS
    .el-form-item::v-deep {
        margin-bottom: 16px;

        .el-form-item__label {
            font-size: 13px;
            font-weight: 500;
            line-height: 20px;
            color: #8492A6;
            margin-bottom: 5px;
            display: flex;
            flex-direction: row-reverse;
            white-space: nowrap;

            &:before {
                margin-right: 0 !important;
                margin-left: 4px;
                color: #8492A6 !important;
            }
        }
        .el-form-item__content {
            line-height: unset;

            .el-form-item__error {
                font-size: 10px;
                padding-top: 3px;
            }
        }

        &:not(.is-error) {
            .el-input__inner {
                border-color: #E5E9EF;
            }
        }

        &.is-error {
            .el-input-group--prepend {
                .el-input-group__prepend {
                    border-color: #F56C6C;

                }
            }
            .el-form-item__content {
                .gmap-autocomplete {
                    .pac-target-input {
                        border-color: #F56C6C;
                    }
                }
            }
            .el-select {
                .el-input__inner {
                    border-color: #F56C6C;
                }
            }
        }
    }

    // INPUTS
    .el-input::v-deep {
        .el-input__inner {
            padding: 10px 16px;
            border-radius: var(--input-border-radius);
            height: 44px;
        }

        &.el-input-group--prepend {
            .el-input-group__prepend {
                border-radius: var(--input-border-radius) 0 0 var(--input-border-radius);
            }
            .el-input__inner {
                border-left: none;
                border-radius: 0 var(--input-border-radius) var(--input-border-radius) 0;
            }
        }
    }

    // BUTTONS
    .el-button {
        border: none;
        border-radius: var(--input-border-radius);
        box-sizing: border-box;
        height: 44px;
        font-size: 16px;
        font-weight: 500;
        width: 100%;

        &.el-button--primary {
            background-color: var(--color-primary);

            &:hover {
                background-color: var(--color-primary);
            }
        }
        &.is-disabled {
            opacity: 0.4;
        }
    }

    // CREDIT CARD DETAILS SECTION
    .stripe-card {
        border: 1px solid #E5E9EF;
        border-radius: var(--input-border-radius);
        height: 44px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 44px;
        outline: none;
        padding: 0 16px;
        margin-top: 0;
    }
    .card-errors {
        font-size: 10px;
        padding-top: 3px;
        color: #F56C6C;
        line-height: 1;
    }

    // GIFT CARD
    .card-front, .card-back {
        position: relative;
        margin-bottom: 20px;

        .svg-test {
            position: inherit !important;
            visibility: hidden;
        }

        svg {
            width: 100%;
            height: auto;
            position: absolute;
            top: 0;
            left: 0;
            border: 1px solid var(--color-primary);
            border-radius: 25px;
        }

        .card-info {
            width: 100%;
            height: 100%;

            .text {
                color: white;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                position: absolute;
                top: 0;
                height: calc(100% - 40px);
                width: calc(100% - 40px);
                padding: 20px;

                .company-name {
                    font-size: 20px;
                    font-weight: 600;
                }

                .amount {
                    font-size: 42px;
                    font-weight: 700;
                    text-align: right;
                }

                .description {
                    font-size: 16px;
                }

                .code {
                    font-size: 18px;
                    font-weight: 500;
                }
            }

        }
    }

    .card-back {
        svg {
            transform: scaleX(-1);
        }
    }


    // RESPONSIVE DESIGN
    @media (max-width: 992px) {
        .sidebar, .column-divider {
            display: none !important;
        }
    }

    @media (max-width: 768px) {
        .card {
            padding: 30px 24px;
        }
        .card-brands {
            flex-direction: column-reverse;
            gap: 8px;
        }
    }

    /* .no-captcha::v-deep {
        .nc_wrapper {
            width: 100% !important;
        }
        .nc_scale {
            height: 48px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            .scale_text {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
            }
            .btn_slide, .btn_ok {
                border-radius: 0 10px 10px 0;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .btn_ok {
                border-radius: 0 10px 10px 0;
            }
        }
        .nc_scale .nc_bg {
            border-radius: 10px 0 0 10px;
            display: flex;
            align-items: center;
            border: 1px solid #BDBDBD;
        }
    } */

</style>
